import React from "react";
import { Button, PropTypes as ButtonProps } from "@jmc/solid-design-system/src/components/atoms/Button/Button";
import style from "./style.module.scss";
import classnames from "classnames";

type BannerButtonProps = ButtonProps & { testId: "Dismiss" | "Action"; children: React.ReactNode };

export const BannerButton: React.FC<BannerButtonProps> = ({ className, onClick, testId, children, ...props }) => {
    return (
        <Button
            {...props}
            variant="naked"
            size="small"
            onClick={onClick}
            data-test-id={`Banner.Button.${testId}`}
            noSpacing
            flexibleWidth
            className={classnames(style.bannerButton, className)}
        >
            {children}
        </Button>
    );
};
